/*=========================================================================================
  File Name: moduleCountryActions.js
  Description: Country Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {

  // ==========================================
  // Tax Settings Actions
  // ==========================================
  fetchTaxRate({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("API/TaxSetting", {
        headers: { Authorization: 'Bearer ' + localStorage.accessToken }
      })
      .then((response) => {
        if (response.data && response.data.VatPercentage !== undefined) {
          commit('SET_TAX_RATE', response.data.VatPercentage)
        }
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },

  updateTaxRate({ commit }, vatPercentage) {
    return new Promise((resolve, reject) => {
      axios.post("API/TaxSetting/Update", 
        { vatPercentage: vatPercentage },
        { headers: { Authorization: 'Bearer ' + localStorage.accessToken } }
      )
      .then((response) => {
        commit('SET_TAX_RATE', vatPercentage)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },

  // ==========================================
  // Opportunities Actions
  // ==========================================
  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
    
      axios.post("API/Opportunity/Add", item,
        {headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
      )
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((res) => {
        
          reject(res);

        });
    });
  },
  fetchDataListItems({ commit }, filterTeamLeaders = false) {
  
    return new Promise((resolve, reject) => {
      axios.get("API/Opportunity/GetAllAdmin", {
          headers: {
            Authorization: 'Bearer ' + localStorage.accessToken,
          },
          // Pass the flag as a query parameter
          params: {
            filterTeamLeaders: filterTeamLeaders
          }
        })
        .then((response) => {

          commit('SET_Opportunities', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  

searchOpportunities({ commit }, keySearch) {
  
  return new Promise((resolve, reject) => {
    axios.get(`api/Opportunity/Search?keySearch=${keySearch}`, {
      headers: { Authorization: 'Bearer ' + localStorage.accessToken }
    })
    .then((response) => {
      commit('SET_Opportunities', response.data); 
      resolve(response);
    })
    .catch((error) => { reject(error); });
  });
},


filterOpportunities({ commit }, filters) {
  return new Promise((resolve, reject) => {
    axios.post("api/Opportunity/Filter", filters, {
      headers: { Authorization: 'Bearer ' + localStorage.accessToken }
    })
    .then((response) => {
      commit('SET_Opportunities', response.data);
      resolve(response);
    })
    .catch((error) => { reject(error); });
  });
},
checkIdentityCardExists({ commit }, identityCard) {

      return new Promise((resolve, reject) => {
       axios.get("API/Members/CheckIdentityCard?identityCard=" + identityCard, {
      headers: { Authorization: 'Bearer ' + localStorage.accessToken }
      })
         .then(response => {
        const exists = response.data.exists;
        commit('SET_IdentityCardExists', exists); 
        resolve(exists);
      })
        .catch(error => {
          reject(error);
        });
      });
    },
  GetApprovedMembers({commit}){
  
    return new Promise((resolve, reject) => {
      axios.get("API/Members/GetApprovedMembers"
        ,{headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
      )
        .then((response) => {
          commit('SET_Members', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put("API/Opportunity/Update", item
        ,{headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
      )
        .then(response => {
        
          commit('UPDATE_Opportunities', item);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

fetchOpportunityFees({ commit }, opportunityId) {
    return axios.get(`/api/OpportunityFee/GetByOpportunityId/${opportunityId}`)
      .then(res => commit('SET_OPPORTUNITY_FEES', res.data.Data));
  },


  addFee({ commit }, feeItem) {
    return new Promise((resolve, reject) => {
      
      axios.post("/api/OpportunityFee/Add", feeItem)
        .then(response => {
          const newFee = response.data.Data; 
          commit('ADD_FEE', newFee);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
updateFee({ commit }, feeItem) {
  return new Promise((resolve, reject) => {

    axios.put("/api/OpportunityFee/Update", feeItem) 
      .then(response => {
        const updatedFee = response.data.Data; 
        commit('UPDATE_FEE', updatedFee);
        resolve(response);
      })
      .catch(error => reject(error));
  });
},

  deleteFee({ commit }, feeId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/OpportunityFee/Delete/${feeId}`)
        .then(response => {
          commit('REMOVE_FEE', feeId);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
GetItemByID({ commit }, itemid) {

  return new Promise((resolve, reject) => {

    axios.get(`API/Opportunity/GetById/${itemid}`, {
      headers: { Authorization: 'Bearer ' + localStorage.accessToken }
    })
    .then((response) => {
    
      commit('GET_ITEM_BY_ID', response.data.Data); 
      resolve(response);
    })
    .catch((error) => { reject(error) });
  });
},

  removeItem({ commit }, item) {
    
    return new Promise((resolve, reject) => {
      axios.delete(`API/Opportunity/Delete/${item.Id}`, {
        headers: { Authorization: 'Bearer ' + localStorage.accessToken }
      })
        .then((response) => {
          commit('REMOVE_ITEM', item.id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchOpportunityDocuments({ commit }, opportunityId) {
    return axios.get(`/api/OpportunityDocument/GetByOpportunityId/${opportunityId}`)
      .then(res => commit('SET_OPPORTUNITY_DOCUMENTS', res.data.Data));
  },
  addDocument({ commit }, docItem) {
    return axios.post("/api/OpportunityDocument/Add", docItem)
      .then(res => {
        commit('ADD_OPPORTUNITY_DOCUMENT', res.data.Data);
        return res;
      });
  },
  updateDocument({ commit }, docItem) {
    return axios.put("/api/OpportunityDocument/Update", docItem)
      .then(res => {
        commit('UPDATE_OPPORTUNITY_DOCUMENT', res.data.Data);
        return res;
      });
  },
  deleteDocument({ commit }, id) {
    return axios.delete(`/api/OpportunityDocument/Delete/${id}`)
      .then(() => commit('REMOVE_OPPORTUNITY_DOCUMENT', id));
  }
}
